var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M12.6541 6.26086L16 9.53764L19.3459 6.26086H24.0813L28.3913 10.4602V15.7094L16 27.7826L3.60869 15.7094V10.4602L7.91871 6.26086H12.6541Z",
          fill: "black"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M16 7.09154L18.9917 4.30435H24.9147L29.6957 8.83803V16.951L16 29.9006L2.30435 16.951V8.83803L7.08533 4.30435H13.0083L16 7.09154ZM13.5217 3H6.56522L1 8.27736V17.5127L16 31.6957L31 17.5127V8.27736L25.4348 3H18.4783L16 5.30885L13.5217 3Z",
          fill: "#D0D0D0"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M12.1778 8.21738L16 11.9315L19.8222 8.21738H23.206L26.4348 11.3618V15.0371L16 25.1739L5.56519 15.0371V11.3618L8.79397 8.21738H12.1778Z",
          fill: "#E1503C"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M20.1367 18.4284L23.826 14.7391L22.9037 13.8168L19.2144 17.5061L20.1367 18.4284Z",
          fill: "white"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }